import { Theme, makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles<Theme>(
    (theme: Theme) => ({
        striped: {
            '&:nth-of-type(odd)': {
                backgroundColor: theme.palette.background.default,
            },
        },
    }),
    { name: 'MuiTableRow' },
);

export default useStyles;
